export default __webpack_public_path__ + "static/media/kitchen4-afterB-768w.69672106.png";